module.exports = __webpack_public_path__ + "img/hacktiv8.affa2dd8.webp";